var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-column",class:{
        'menu-column--sidebar': _vm.showAsSidebar,
    }},[(!_vm.showOnlyFooter)?_c('div',{staticClass:"menu-column__main-inner"},[_c('menu-column-item',{attrs:{"items-list":_vm.columnItemsList}})],1):_c('menu-column-footer',{attrs:{"footer-items":_vm.footerInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }